const style = (theme) => {
  const output = {
    root: {
      width: '100vw',
    },
    rootRight: {
      '& $content': {
        order: 99,
      },
    },
    description: {
      extend: theme.smallWrapper,
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      '& > *': {
        flex: '0 0 45%',
        width: '45%',
      },
    },
    content: {},
    nav: {
      marginBottom: 80,
      display: 'flex',
      '& > *:not(:last-child)': {
        marginRight: 25,
      },
      '& button': {
        height: '100%',
        backgroundColor: '#303ec0',
        color: theme.colors[1],
        fontSize: 10,
        letterSpacing: '1px',
        textTransform: 'uppercase',
        padding: [20, 30],
        borderRadius: 30,
        fontWeight: 500,
        cursor: 'pointer',
        transition: `all 0.75s ${theme.easings.garret}`,
        '@media (hover: hover)': {
          '&:hover': {
            backgroundColor: theme.colors[1],
            color: theme.colors[3],
          },
        },
      },
    },
    active: {
      '& button': {
        backgroundColor: theme.colors[1],
        color: theme.colors[3],
        cursor: 'default',
      },
    },
    figure: {
      overflow: 'hidden',
    },
    image: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      paddingBottom: '90%',
      '& img': {
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        height: '100%',
        width: '100%',
        objectFit: 'contain',
      },
    },
    imageBackground: {},
    text: {
      position: 'relative',
      zIndex: 1,
      fontSize: 18,
      lineHeight: 1.5,
      fontWeight: 300,
      pointerEvents: 'none',
      '& > *': {
        position: 'absolute',
        zIndex: 1,
        top: 0,
        left: 0,
        width: '100%',
      },
    },
    activeText: {
      pointerEvents: 'all',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    content: {
      display: 'flex',
      flexDirection: 'column',
    },
    description: {
      flexDirection: 'column',
      '& > *': {
        flex: '0 0 100%',
        width: '100%',
      },
      '& $content': {
        order: '99 !important',
      },
    },
    nav: {
      marginTop: 40,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
